var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.8334H2.33333C2.01117 12.8334 1.75 12.5722 1.75 12.25V1.75002C1.75 1.42786 2.01117 1.16669 2.33333 1.16669H11.6667C11.9888 1.16669 12.25 1.42786 12.25 1.75002V12.25C12.25 12.5722 11.9888 12.8334 11.6667 12.8334ZM11.0833 11.6667V2.33335H2.91667V11.6667H11.0833ZM4.08333 3.50002H6.41667V5.83335H4.08333V3.50002ZM4.08333 7.00002H9.91667V8.16669H4.08333V7.00002ZM4.08333 9.33335H9.91667V10.5H4.08333V9.33335ZM7.58333 4.08335H9.91667V5.25002H7.58333V4.08335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.685b5bf1b3def4421af02573f8e82317.svg";
export { ForwardRef as ReactComponent };